import styled from "styled-components";

export const HeaderContainer = styled.div`
  position: fixed;
  width: 85%;
  height: 12%;
  background-color: #fff;
  display: inline-flex;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  z-index: 300;
  @media (max-width: 768px) {
    width: 100%;
    font-size: 0.75rem;
  }
`;

export const HeaderTitle = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 1.875rem;
  padding-left: 2rem;
  padding-top: 1.6rem;
  @media (max-width: 768px) {
    padding-left: 1rem;
    padding-top: 0rem;
    font-size: 1.125rem;
  }
`;

export const HeaderSiteLogo = styled.div`
  margin-right: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    margin-right: 1rem;
  }
`;
